export const CARD_NUMBER_PATTERN = /^[0-9A-Z]{4,32}$/;

export function normalizeCardNumber(value) {
    return String(value ?? "").replace(/[\s:-]/g, "").toUpperCase();
}
